module.exports = __webpack_public_path__ + "img/QR-1580x780.3bd44a0e.png";